import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error Untyped module
import { updateOptimisticLockingForRequest } from 'ContentEditorUI/redux/actions/appActions';
import { getSubcategory } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import http from 'hub-http/clients/apiClient';
// @ts-expect-error Untyped module
import { getBaseContentUrl } from 'ContentEditorUI/api/ContentApi';
// @ts-expect-error Untyped module
import { getBaseApiUrl } from 'ContentEditorUI/redux/selectors/extraInitialStateSelectors';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { fetchContent, fetchHardSavedContent
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/contentActions';
import usageTracker from 'ContentEditorUI/utils/UsageTracker';
import { userInfoSync } from 'hub-http/userInfo';
import I18n from 'I18n';
import { getHardSavedContentModelScheduledUpdateDate } from 'ContentEditorUI/redux/selectors/hardSavedContentModelSelectors';
import { getPublishDate, getContentModelPageExpiryDate } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { updateExpiryDate, updateExpiryEnabled, updateExpiryRedirectUrl
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/baseContentModelActions';
import { getContentModelId } from '../../../../redux/selectors/baseContentModelSelectors';
import { PublishTypes } from '../../../../constants/PublishTypes';
import useContentCrmObject from '../../hooks/useContentCrmObject';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
import { PublishActionTypes } from '../../types/publishButtonTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const getCancelSchedulePublishOrUpdateUrl = state => {
  const baseUrl = getBaseContentUrl({
    baseUrl: getBaseApiUrl(state),
    categoryId: getCategoryId(state),
    subcategory: getSubcategory(state),
    contentId: getContentModelId(state)
  });
  return `${baseUrl}/cancel-scheduled-publish`;
};
const getContentCrmObjectDateTimeOptions = contentCrmObject => {
  if (!contentCrmObject) {
    return null;
  }
  const unpublishDate = getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_UNPUBLISH_DATE);
  const scheduledPublishDate = getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_PUBLISH_DATE);
  return {
    portalTimezone: userInfoSync().portal.timezone.id,
    scheduledTime: I18n.moment(scheduledPublishDate)
    // @ts-expect-error portalTz() isn't typed
    .portalTz().format('LLL'),
    unpublishTime: I18n.moment(unpublishDate)
    // @ts-expect-error portalTz() isn't typed
    .portalTz().format('LLL')
  };
};
const CancelScheduleConfirmModal = ({
  closeModal,
  isScheduleUpdate,
  actionTypeBodyInfoKey,
  publish
}) => {
  const apiUrl = useSelector(getCancelSchedulePublishOrUpdateUrl);
  const params = {
    baseUrl: useSelector(getBaseApiUrl)
  };
  const dispatch = useDispatch();
  const {
    contentCrmObjectId,
    contentObjectType,
    canScheduleWithContentCrmObject,
    contentCrmObject,
    reconcileContentCrmObjectForPublishActions
  } = useContentCrmObject();
  const scheduledUpdateDate = useSelector(getHardSavedContentModelScheduledUpdateDate);
  const publishDate = useSelector(getPublishDate);
  const unpublishDate = useSelector(getContentModelPageExpiryDate);
  const dateTimeCopyOptions = getContentCrmObjectDateTimeOptions(contentCrmObject) || {
    portalTimezone: userInfoSync().portal.timezone.id,
    scheduledTime: I18n.moment(scheduledUpdateDate || publishDate)
    // @ts-expect-error portalTz() isn't typed
    .portalTz().format('LLL'),
    unpublishTime: I18n.moment(unpublishDate)
    // @ts-expect-error portalTz() isn't typed
    .portalTz().format('LLL')
  };
  const handleCancelScheduleUnpublish = () => {
    dispatch(updateExpiryEnabled(false));
    dispatch(updateExpiryDate(null));
    dispatch(updateExpiryRedirectUrl(null, [], null));
    publish(PublishTypes.cancelScheduledUnpublish);
    closeModal();
  };
  const handleCancelScheduleWithCMP = () => {
    http.postWithResponse(`content-management/publication/v1/${contentObjectType}/${contentCrmObjectId}/schedule/${actionTypeBodyInfoKey === 'scheduleUnpublish' ? 'unpublish' : 'publish'}/async/cancel`).then(response => {
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `cancelScheduleConfirmModal.success.title.${actionTypeBodyInfoKey}`
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `cancelScheduleConfirmModal.success.message.${actionTypeBodyInfoKey}` // TODO: fix the messages for various cancel actions
        }),
        type: 'success'
      });
      dispatch(updateOptimisticLockingForRequest({
        hasSaved: true,
        xLastModifiedTimestampHeader: response.headers['x-last-modified-timestamp']
      }));
      reconcileContentCrmObjectForPublishActions(actionTypeBodyInfoKey === 'scheduleUnpublish' ? PublishActionTypes.CANCEL_SCHEDULED_UNPUBLISH : PublishActionTypes.CANCEL_SCHEDULED_PUBLISH);
      usageTracker.track(isScheduleUpdate ? 'cancelUpdate' : 'cancelPublish');
      closeModal();
    }).catch(() => {
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.failure.title"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cancelScheduleConfirmModal.failure.message"
        }),
        type: 'danger'
      });
    });
  };
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `cancelScheduleConfirmModal.header.${actionTypeBodyInfoKey}`
    }),
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `cancelScheduleConfirmModal.body.${actionTypeBodyInfoKey}`,
      options: dateTimeCopyOptions
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `cancelScheduleConfirmModal.footer.${actionTypeBodyInfoKey}`
    }),
    onConfirm: () => {
      if (canScheduleWithContentCrmObject) {
        handleCancelScheduleWithCMP();
        return;
      }
      if (actionTypeBodyInfoKey === 'scheduleUnpublish') {
        handleCancelScheduleUnpublish();
        return;
      }
      http.postWithResponse(apiUrl).then(response => {
        FloatingAlertStore.addAlert({
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `cancelScheduleConfirmModal.success.title.${actionTypeBodyInfoKey}`
          }),
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `cancelScheduleConfirmModal.success.message.${actionTypeBodyInfoKey}` // TODO: fix the messages for various cancel actions
          }),
          type: 'success'
        });
        dispatch(updateOptimisticLockingForRequest({
          hasSaved: true,
          xLastModifiedTimestampHeader: response.headers['x-last-modified-timestamp']
        }));
        dispatch(fetchContent(params));
        dispatch(fetchHardSavedContent(params));
        usageTracker.track(isScheduleUpdate ? 'cancelUpdate' : 'cancelPublish');
        closeModal();
      }).catch(() => {
        FloatingAlertStore.addAlert({
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cancelScheduleConfirmModal.failure.title"
          }),
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cancelScheduleConfirmModal.failure.message"
          }),
          type: 'danger'
        });
      });
    },
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cancelScheduleConfirmModal.footer.exit"
    }),
    onReject: closeModal,
    size: "auto"
  });
};
export default CancelScheduleConfirmModal;